import { ExamFormContainerComponent } from './shared/views/exam-form-container/exam-form-container.component';
import { AppGuard } from './helpers/app.guard';
import { AuthGuard } from './helpers/auth.guard';
import { AuthRoutingModule } from './auth/auth-routing.module';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// COMPONENTS
import { CentroDeAyudaComponent } from './shared/views/centro-de-ayuda/centro-de-ayuda.component';
import { NotFoundComponent } from './shared/views/not-found/not-found.component';
import { LoginComponent } from './auth/components/login/login.component';
import { ExamsComponent } from '@shared/views/exams/exams.component';
import { ExamnsTemplateContainerComponent } from './shared/forms/examns-template-container/examns-template-container.component';
import { ShowExamnsTemplateContainerComponent } from './shared/forms/show-examns-template-container/show-examns-template-container.component';
import { EditExamenTemplateContainerComponent } from './shared/forms/edit-examen-template-container/edit-examen-template-container.component';
import { AgendasComponent } from './shared/views/agendas/agendas.component';
import { AgendaFormComponent } from './shared/components/agenda-form/agenda-form.component';

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'examenes' },
  {
    path: 'examenes',
    component: ExamsComponent,
    canActivate: [AuthGuard, AppGuard],
    data: { roles: ['PRESTADOR', 'OFF'] },
  },
  {
    path: 'examenes/:actualizar',
    component: ExamsComponent,
    canActivate: [AuthGuard, AppGuard],
    data: { roles: ['PRESTADOR', 'OFF'] },
  },
  {
    path: 'examen/:categoriaExamen/:tipoExamen/:codigoTipoExamen/:id',
    component: ExamnsTemplateContainerComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'ver/examen/:codigoTipoExamen/:id',
    component: ShowExamnsTemplateContainerComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'editar/examen/:codigoTipoExamen/:id',
    component: EditExamenTemplateContainerComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'agendas',
    component: AgendasComponent,
    canActivate: [AuthGuard, AppGuard],
    data: { roles: ['PRESTADOR', 'OFF'] },
  },
  { path: 'agendas/:id',
    component: AgendaFormComponent,
    canActivate: [AuthGuard],
    data: { roles: ['PRESTADOR', 'OFF'] },
  },
  {
    path: 'centro-de-ayuda',
    component: CentroDeAyudaComponent,
    canActivate: [AuthGuard, AppGuard],
    data: { roles: ['PRESTADOR', 'AUDITOR', 'OFF'] },
  },
  { path: 'notFound', component: NotFoundComponent, canActivate: [AuthGuard] },
  { path: '404', component: NotFoundComponent, canActivate: [AuthGuard] },
  { path: '**', redirectTo: '/404' },
  { path: 'login', component: LoginComponent },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'top'
}),
    AuthRoutingModule,
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
